/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SequenceItem,
  SequenceItem$inboundSchema,
  SequenceItem$Outbound,
  SequenceItem$outboundSchema,
} from "./sequenceitem.js";

/**
 * The sequence value
 */
export type Sequence = {
  /**
   * The table of sequence items
   */
  table: Array<SequenceItem>;
};

/** @internal */
export const Sequence$inboundSchema: z.ZodType<
  Sequence,
  z.ZodTypeDef,
  unknown
> = z.object({
  table: z.array(SequenceItem$inboundSchema),
});
/** @internal */
export type Sequence$Outbound = {
  table: Array<SequenceItem$Outbound>;
};

/** @internal */
export const Sequence$outboundSchema: z.ZodType<
  Sequence$Outbound,
  z.ZodTypeDef,
  Sequence
> = z.object({
  table: z.array(SequenceItem$outboundSchema),
});

export function sequenceToJSON(sequence: Sequence): string {
  return JSON.stringify(Sequence$outboundSchema.parse(sequence));
}
export function sequenceFromJSON(
  jsonString: string,
): SafeParseResult<Sequence, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Sequence$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Sequence' from JSON`,
  );
}
